
import { defineComponent } from "vue";
import FlagIcon from "@/components/icon/FlagIcon.vue";

export default defineComponent({
  components: { FlagIcon },
});
